import { render, staticRenderFns } from "./BSBadge.vue?vue&type=template&id=519a3560&"
import script from "./BSBadge.vue?vue&type=script&lang=js&"
export * from "./BSBadge.vue?vue&type=script&lang=js&"
import style0 from "./BSBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports